import { Button } from "components/shadcn/button";
import React from "react";
import {InfinityCircularLoadingIcon} from "components/common/Icons/InfinityCircularLoadingIcon";
import {translate} from "components/common/Translate/Translate";

const LoginButton = ({ title, pending = false }: { title: string, pending:boolean }) => {
    return (
        <Button type="submit" disabled={pending} className="w-full bg-irBlue-200 text-white hover:bg-irBlue-400 mt-2" data-automation-id="submitButton"
>
            {!pending && title}
            {pending && (<>
                <InfinityCircularLoadingIcon className="stroke-white animate-spin-slow mr-1" />
                {translate('submitting')}
            </>)}
        </Button>
    );
};

export default LoginButton;
